/**
 * A tip, never required (2026-10-19, the owner). Only when the server has a tip link
 * (SUPPORT_URL, /api/v1/site).
 *
 * 2026-10-23, the owner: "remove the pop up tip, make it only as an icon on every page". The
 * window that came before a download, share, print or save is gone; what is left is a red
 * heart at the top of every signed-in page, which opens the tip link (the Venmo page) in a
 * new tab.
 */
import { useSite } from './idle.tsx';
import { t } from './strings.ts';

/** Whether a tip link goes to Venmo, so the icon can say so. */
export const isVenmo = (url: string) => {
  try {
    return /(^|\.)venmo\.com$/i.test(new URL(url).hostname);
  } catch {
    return false;
  }
};

/** The tip icon, for the top of every signed-in page: a red heart that opens the tip link. */
export function TipButton() {
  const site = useSite();
  if (!site?.supportUrl) return null;
  const label = isVenmo(site.supportUrl) ? t('tipVenmo') : t('supportButton');
  return (
    <a className="button tip-btn no-print" href={site.supportUrl} target="_blank" rel="noopener noreferrer"
      title={label} aria-label={label}>
      <span className="tip-heart" aria-hidden="true">♥</span>
    </a>
  );
}
